<template>
    <div>
        <allTitle ref="allTitle" />

        <!-- 信息框 -->
        <el-dialog title="" :visible.sync="dialogVisibleUser" width="35%" :before-close="handleClose"
            :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" center>
            <div>
                <div style="text-align: center;font-weight: 540;font-size: 22px;padding: 10px;color: #333333">
                    欢迎您，登录Qsou广场
                </div>
                <div style="text-align: center;padding: 5px;color: #333333;font-weight: 330;">完善账号信息，更好地做生意，玩社交！</div>
                <div style="width: 60%;margin: auto;">

                    <el-input v-model="name" maxlength="10" style="margin-top: 10px;width: 100%;" placeholder="昵称"
                        show-word-limit>
                    </el-input>
                    <el-input v-model="user_motto" maxlength="16" style="margin-top: 10px;width: 100%;"
                        placeholder="座右铭" show-word-limit>
                    </el-input>

                    <el-input v-model="career" maxlength="10" style="margin-top: 10px;width: 100%;" placeholder="从事行业"
                        show-word-limit> </el-input>
                    <el-select v-model="identity" placeholder="请选择身份" style="margin-top: 10px;width: 100%;">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>


                    <el-input v-model="interest" maxlength="20" style="margin-top: 10px;width: 100%;" placeholder="兴趣爱好"
                        show-word-limit> </el-input>
                    <!-- <el-input v-model="email" maxlength="20" style="margin-top: 10px;width: 100%;" placeholder="邮箱地址"
                        show-word-limit> </el-input>
                    <el-input v-model="age" maxlength="3" style="margin-top: 10px;width: 100%;" placeholder="年龄"
                        show-word-limit @input="handleInput">
                    </el-input> -->
                    <el-input v-model="phone" maxlength="11" style="margin-top: 10px;width: 100%;" placeholder="联系方式"
                        show-word-limit @input="handleInput2">
                    </el-input>
                    <el-cascader style="margin-top: 10px;width: 100%;" v-model="user_address" :options="options2"
                        filterable placeholder="地区"></el-cascader>


                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="changeUser">提 交</el-button>
            </span>
        </el-dialog>
        <!--  -->
    </div>
</template>

<script>
import { getAllRegion, updateUserByUserId, getUserById } from '../api/user'
import allTitle from '../components/allTitle.vue'
export default {
    data() {
        return {
            user_motto: '',
            dialogVisibleUser: false,
            age: '',
            interest: '',
            career: '',
            name: '',
            // options2: [],
            phone: '',
            email: '',
            user_address: [],
            identity: '',
            options: [{
                value: '自由职业者',
                label: '自由职业者'
            }, {
                value: '老板',
                label: '老板'
            }, {
                value: '业务员',
                label: '业务员'
            }, {
                value: '高管',
                label: '高管'
            }, {
                value: '运营',
                label: '运营'
            },
            {
                value: '个体户',
                label: '个体户'
            },
            {
                value: '老师',
                label: '老师'
            },
            {
                value: '技术能手',
                label: '技术能手'
            },
            {
                value: '学生',
                label: '学生'
            },
            {
                value: '经理',
                label: '经理'
            },
            {
                value: '博主',
                label: '博主'
            },

            ],
        }
    },
    methods: {

        titleShow(msg) {
            this.$refs.allTitle.msg = msg;
            this.$refs.allTitle.routerPath = null;
            this.$refs.allTitle.dialogVisible = true;
        },
        changeUser() {
            let userId = window.localStorage.getItem("user_id");

            let params = {
                user_id: userId,
                user_name: this.name,
                user_phone: this.phone,
                user_email: this.email,
                shop_id: '',
                identity: this.identity,
                age: this.age,
                user_address: this.user_address,
                interest: this.interest,
                career: this.career,
                user_sex: this.user_sex,
                user_motto: this.user_motto,
            };
            if (!this.phone) {
                return this.titleShow('请输入联系方式')
            }
            if (!this.identity) {
                return this.titleShow('请输入身份')
            }
            if (!this.career) {
                return this.titleShow('请输入从事行业')
            }
            if (!this.age) {
                return this.titleShow('请输入年龄')
            }
            if (!this.name) {
                return this.titleShow('请输入昵称')
            }
            if (this.user_address.length == 0) {
                return this.titleShow('请输入地区')
            }

            updateUserByUserId(params).then((res) => {
                if (res.data.code == 200) {
                    this.$message({
                        type: "success",
                        message: "提交成功"
                    });
                    this.dialogVisibleUser = false
                } else {
                    this.$message({
                        type: "error",
                        message: '系统错误'
                    });
                }
            });
        },
        handleClose() {
            this.dialogVisibleUser = false
        },
        handleInput(value) {
            this.age = value.replace(/[^\d]/g, "");

        },
        handleInput2(value) {
            this.phone = value.replace(/[^\d]/g, "");

        }
    },

    components: { allTitle },
    created() { },
    props: ['options2'],
    mounted() {
        // getAllRegion().then((res) => {
        //     this.options2 = res.data.data;

        // });
        console.log('进来了----');

        let user_id = window.localStorage.getItem("user_id");
        // if (user_id) {
        //     getUserById().then((res) => {
        //         console.log(res, 'ddddd----');
        //         if (!res.data.data.interest || !res.data.data.user_email) {
        //             this.dialogVisibleUser = true
        //             this.phone = res.data.data.user_phone
        //             this.interest = res.data.data.interest
        //             this.identity = res.data.data.identity
        //             this.user_address = [res.data.data.area_one, res.data.data.area_two]
        //             this.email = res.data.data.user_email
        //             this.age = res.data.data.age
        //             this.name = res.data.data.user_name
        //             this.career = res.data.data.career

        //         }
        //     })
        // }

    }
}
</script>

<style lang=scss scoped>
::v-deep .el-dialog {
    border-radius: 20px;
}
</style>
